export default __webpack_public_path__ + "static/media/insta-sp.68694ea2.webp";